import { Button, ButtonVariant, Icon } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { useLandingStore } from "src/modules/pe-landing-module/data/store"
import { ITitleProps } from "../section/Title"
import { ICurrentEditType } from "./landing-edit-modal"

/* Protopia Ecosystem component */
export interface ITitleDummyProps extends ITitleProps {
   
}
const TitleDummy = (props: ITitleDummyProps): JSX.Element => {
    const onClick = () => {
        useLandingStore.setState({ 
            curEditModal: { 
                ...props.section.title, 
                sectionId: props.section.id, 
                currentEditType: SELECT_TYPE.TITLE
            } as ICurrentEditType
        }) 
    }
    return props.section.title?.text 
        ?
        <></>
        :
        <Button variant={ ButtonVariant.OUTLINED } className='btn-stretch p-0 pe-title-dummy mr-1 ' onClick={onClick}>
            <div className="micro text-uppercase letter-spacing-1 px-3 py-2 bg-plain-opacity">
                <Icon  icon="edit" className="mr-1" size={11} />
                { __( "Insert title" ) }
            </div>
        </Button>
}
export default TitleDummy